import { createReducer } from '../../utils/misc'

import {
  FETCH_CREDIT_REQUEST,
  FETCH_CREDIT_SUCCESS,
  FETCH_CREDIT_ERROR,
  FETCH_CREDIT_RESULT_SUCCESS,
  FETCH_CREDIT_RESULT_ERROR,
  LOADING_SIMULATION_RESULT,
  GET_SIMULATION_CREDIT,
  NEXT_STEP_SIMULATION,
  PREV_STEP_SIMULATION,
  PUT_DECLARACION_JURADA,
  USER_PENDIENTE_PC
} from '../constants/credit'

const initialState = {
  // Oferta de Crédito
  creditOffer: {
    cuotas: {
      min: 0,
      max: 0
    },
    amount: {
      min: 0,
      max: 0
    },
    seguros: {
      cesantia: true,
      desgravam: false
    },
    tipoTrabajador: 0,
    error: null,
    loading: true,
    isElegible: false
  },
  // Resultado de Simulación
  creditSimulation: {
    cae: '-',
    cuotaMensual: 0,
    simulationId: null,
    tasaInteres: '0%',
    totalCredito: 0,
    vencimiento: '-',
    error: null,
    loading: false,
    completed: false
  },
  // Simulación Usuario
  userSimulation: {
    amount: 0,
    percentage: 0,
    coutas: 0,
    seguros: {
      cesantia: true,
      desgravam: true
    },
    tipoTrabajador: 1
  },
  currentStep: 0,
  declaracionJurada: null,
  pendientePC: false
}

export default createReducer(initialState, {
  [FETCH_CREDIT_REQUEST]: (state) =>
    Object.assign({}, state, {
      creditOffer: {
        ...state.creditOffer,
        loading: true,
        error: null
      }
    }),
  [FETCH_CREDIT_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      creditOffer: {
        ...payload,
        seguros: {
          cesantia: true,
          desgravam: true
        },
        loading: false,
        tipoTrabajador: 0
      }
    }),
  [FETCH_CREDIT_ERROR]: (state, payload) =>
    Object.assign({}, state, {
      creditOffer: {
        ...state.creditOffer,
        loading: false,
        error: payload
      }
    }),
  [FETCH_CREDIT_RESULT_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      creditSimulation: {
        ...payload,
        loading: false,
        error: null,
        completed: true
      }
    }),
  [FETCH_CREDIT_RESULT_ERROR]: (state, payload) =>
    Object.assign({}, state, {
      creditSimulation: {
        ...state.creditSimulation,
        error: payload,
        loading: false,
        completed: false
      }
    }),
  [GET_SIMULATION_CREDIT]: (state, payload) =>
    Object.assign({}, state, {
      userSimulation: payload
    }),
  [LOADING_SIMULATION_RESULT]: (state) =>
    Object.assign({}, state, {
      creditSimulation: {
        ...state.creditSimulation,
        loading: true,
        error: null
      }
    }),
  [NEXT_STEP_SIMULATION]: (state) =>
    Object.assign({}, state, {
      currentStep: state.currentStep + 1
    }),
  [PREV_STEP_SIMULATION]: (state) =>
    Object.assign({}, state, {
      currentStep: state.currentStep - 1
    }),
  [PUT_DECLARACION_JURADA]: (state) =>
  Object.assign({}, state, {
    declaracionJurada: true
  }),
  [USER_PENDIENTE_PC]: (state, payload) =>
    Object.assign({}, state, {
      pendientePC: payload
  })
})